export const ROTA_HUB_OFERTAS = "/admin/impulsione/relatorio-ofertas";
export const ROTA_CUPONS = "/admin/impulsione/relatorio-ofertas/cupons";
export const ROTA_PROMOCOES = "/admin/impulsione/relatorio-ofertas/promocoes";
export const ROTA_CARTAO_FIDELIDADE = "/admin/impulsione/relatorio-ofertas/cartao-fidelidade";
export const rotaCupom = (chave) => `${ROTA_CUPONS}/${encodeURIComponent(chave)}`;
export const rotaPromocao = (chave) => `${ROTA_PROMOCOES}/${encodeURIComponent(chave)}`;
// Anúncios Meta (04/10/2026): gasto da Meta × pedidos do Núcleo por campanha. Desde
// 27/10/2026 é um relatório próprio do menu, fora do Relatório de Ofertas.
export const ROTA_META_ADS = "/admin/relatorios/anuncios-meta";
export const rotaCampanhaMeta = (chave) => `${ROTA_META_ADS}/${encodeURIComponent(chave)}`;
